import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import { getRejectedNotesCount } from "../queryFunctions/getRejectedNotesCount";
import { rejectedNotesCountKeys } from "../keyFactory";

type RejectedNotesCountQueryOptions = UseQueryOptions<
  number,
  unknown,
  number,
  ReturnType<typeof rejectedNotesCountKeys.count>
>;

function optionFactory() {
  return {
    queryFn: getRejectedNotesCount,
    queryKey: rejectedNotesCountKeys.count(),
  } satisfies RejectedNotesCountQueryOptions;
}

export function useRejectedNotesCount() {
  return useQuery(optionFactory());
}
